__turbopack_context__.v({
  "medium": "paragraph-module-scss-module__9J7TjG__medium",
  "pad-bottom": "paragraph-module-scss-module__9J7TjG__pad-bottom",
  "pad-top": "paragraph-module-scss-module__9J7TjG__pad-top",
  "paragraph": "paragraph-module-scss-module__9J7TjG__paragraph",
  "responsive-image": "paragraph-module-scss-module__9J7TjG__responsive-image",
  "skeleton": "paragraph-module-scss-module__9J7TjG__skeleton",
  "small": "paragraph-module-scss-module__9J7TjG__small",
  "step-almost-black": "paragraph-module-scss-module__9J7TjG__step-almost-black",
  "step-amethyst": "paragraph-module-scss-module__9J7TjG__step-amethyst",
  "step-before-midnight": "paragraph-module-scss-module__9J7TjG__step-before-midnight",
  "step-black": "paragraph-module-scss-module__9J7TjG__step-black",
  "step-black-v2": "paragraph-module-scss-module__9J7TjG__step-black-v2",
  "step-coal-mine-canary": "paragraph-module-scss-module__9J7TjG__step-coal-mine-canary",
  "step-coal-mine-canary-down": "paragraph-module-scss-module__9J7TjG__step-coal-mine-canary-down",
  "step-cold-steel": "paragraph-module-scss-module__9J7TjG__step-cold-steel",
  "step-cyanora": "paragraph-module-scss-module__9J7TjG__step-cyanora",
  "step-cyanora-down": "paragraph-module-scss-module__9J7TjG__step-cyanora-down",
  "step-dark-gray": "paragraph-module-scss-module__9J7TjG__step-dark-gray",
  "step-dark-text": "paragraph-module-scss-module__9J7TjG__step-dark-text",
  "step-diagonal-gradient-midnight-haze-to-black": "paragraph-module-scss-module__9J7TjG__step-diagonal-gradient-midnight-haze-to-black",
  "step-future-fuscia": "paragraph-module-scss-module__9J7TjG__step-future-fuscia",
  "step-future-fuscia-down": "paragraph-module-scss-module__9J7TjG__step-future-fuscia-down",
  "step-light-text": "paragraph-module-scss-module__9J7TjG__step-light-text",
  "step-linear-gradient-cyanora-to-future-fuscia": "paragraph-module-scss-module__9J7TjG__step-linear-gradient-cyanora-to-future-fuscia",
  "step-midnight": "paragraph-module-scss-module__9J7TjG__step-midnight",
  "step-negative": "paragraph-module-scss-module__9J7TjG__step-negative",
  "step-off-white": "paragraph-module-scss-module__9J7TjG__step-off-white",
  "step-positive": "paragraph-module-scss-module__9J7TjG__step-positive",
  "step-right-before-black": "paragraph-module-scss-module__9J7TjG__step-right-before-black",
  "step-right-before-midnight": "paragraph-module-scss-module__9J7TjG__step-right-before-midnight",
  "step-secondary-text": "paragraph-module-scss-module__9J7TjG__step-secondary-text",
  "step-vertical-gradient-cyanora-to-future-fuscia": "paragraph-module-scss-module__9J7TjG__step-vertical-gradient-cyanora-to-future-fuscia",
  "step-warning": "paragraph-module-scss-module__9J7TjG__step-warning",
  "step-white": "paragraph-module-scss-module__9J7TjG__step-white",
});
